module.exports = __webpack_public_path__ + "static/img/b32.d40deb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/b32.png
// module id = +D6/
// module chunks = 73